import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MessageService,  } from '@philips-internal/oswald-ui-core/lib/services';
import BaseController from '../BaseController';
import { getFoundationDataContext } from '../../app/bootstrap-foundation';
import { Inject } from '@odinjs/odin';
import { ModalProps, ModalService, TextAPI, ThemeTonalRange, ToastNotificationAPI } from '@philips-internal/oswald-ui-components';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { AccountCreationCompletedAliases } from '../../codegen';
import { generateUUID } from '@philips-internal/oswald-ui-utils';

@Controller({ component: 'layout-account-creation-completed', fragment: 'account-creation-completed' })
export default class AccountCreationModalController extends BaseController {

  @Inject('toast-account-creation-error')
    toast!: ToastNotificationAPI;

  @Inject(AccountCreationCompletedAliases.TEXT_SUCCCESS_SUBTITLE)
    subTitle!: TextAPI;

  @OnClick({ target: AccountCreationCompletedAliases.BUTTON_CLOSE })
  onCloseModalAccountCreation(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

  openModalConfirmationSmsCode():void{
    const modalProps : ModalProps = {
      closeable: false,
      closeByDocument: false,
      closeByEscape: false,
      focusOnOpen: true,
      fragment:'account-creation-confirmation-sms-code',
      onBeforeClose: () => this.handleCloseSMSModal(),
      theme: ThemeTonalRange.ULTRA_LIGHT,
      title: MessageService.translate('account.confirmation.modal.title'),
      uuid: generateUUID(),
    };

    ModalService.openFullscreen(modalProps);
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

  handleCloseSMSModal():void{
    const applicationContext = getFoundationDataContext();
    applicationContext.set({ newSubTitle: 'patient.message.new-account-sms', validationType: undefined });
    this.historyService.push(APPLICATION_ROUTES.ACCOUNT_CREATION_COMPLETED);
  }

  @OnMount({target: AccountCreationCompletedAliases.LAYOUT_ACCOUNT_CREATION_COMPLETED})
  onMountRoor():void{
    const applicationContext = getFoundationDataContext();
    const validationType =  applicationContext.get('validationType');
    if( validationType === 'S' ){
      this.openModalConfirmationSmsCode();
    }

    const newSubtitle = applicationContext.get('newSubTitle');
    if(newSubtitle) {
      applicationContext.set({ newSubTitle: undefined });
      this.subTitle.setValue(MessageService.translate(newSubtitle))
    }
  }

}